<mat-dialog-content class="action-dialog">
  <h2>Notificatiemail</h2>

  <mat-spinner
    *ngIf="!init"
    style="margin:auto;"
    color="primary"
    diameter="24"
  ></mat-spinner>

  <div *ngIf="init">
    <div class="form-sub-title">Selecteer ontvangers</div>

    <mat-form-field class="" appearance="outline">
      <mat-select
        matInput
        multiple
        placeholder="Ontvangers"
        name="recipients"
        [(ngModel)]="selectedRecipients"
        [compareWith]="compareRecipients"
      >
        <mat-option *ngFor="let option of recipientOptions" [value]="option">
          {{ option.firstName | personName: option.lastName }}:
          {{ option.email }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <div class="form-sub-title">Geselecteerde ontvangers</div>
    <div *ngIf="selectedRecipients == null || selectedRecipients.length === 0">
      Geen ontvangers geselecteerd
    </div>
    <ul>
      <li *ngFor="let recipient of selectedRecipients">
        {{ recipient.firstName | personName: recipient.lastName }}:
        {{ recipient.email }}
      </li>
    </ul>

    <textarea-input
      [placeholder]="'Vul hier extra info in'"
      [initContent]="actionInfo"
      (answer)="actionInfoChanged($event)"
    ></textarea-input>
  </div>
</mat-dialog-content>
<mat-dialog-actions class="float-right">
  <button type="button" (click)="closeDialog()" class="btn btn-main btn-back">
    Annuleer
  </button>
  <button
    type="button"
    (click)="performAction()"
    mat-button
    class="button"
    id="btnSend"
    [disabled]="sending"
  >
    Versturen
  </button>
</mat-dialog-actions>
